import { Grid } from '@mui/material'

import ToolTabs from './ToolTabs'
import DeviceViewButtons from './DeviceViewButtons'
import { useToolBuilder } from '../../Hook'

function Nav({
  toolTabValue,
  setToolTabValue,
  livePreviewWidth,
  setLivePreviewWidth,
}: any) {
  const { isMd } = useToolBuilder()

  return (
    <Grid
      px={2}
      container
      bgcolor="grey.100"
      alignItems="center"
      justifyContent="space-between"
    >
      <ToolTabs toolTabValue={toolTabValue} setToolTabValue={setToolTabValue} />
      {!isMd && (
        <DeviceViewButtons
          livePreviewWidth={livePreviewWidth}
          setLivePreviewWidth={setLivePreviewWidth}
        />
      )}
    </Grid>
  )
}

export default Nav
